/** Superficie pública del módulo Compras. Re-exporta desde domain-api, infra-api, app-api + UI directa. */

// Layered APIs — importar desde estas para evitar require cycles:
//   domain-api: tipos y funciones puras (cero dependencias)
//   infra-api: repos y queries
//   app-api: intake functions (application layer)
export * from './domain-api';
export * from './infra-api';
export * from './app-api';

// UI — se mantiene directo en public-api para evitar cycles (components/screens importan de otros módulos)
export { PurchasesScreen } from './screens/PurchasesScreen';
export { PurchasesScreenHeader } from './components/PurchasesScreenHeader';
export { PurchaseOrderRowCard } from './components/PurchaseOrderRowCard';
export { PurchaseOrderRegisterModal } from './components/PurchaseOrderRegisterModal';
export { PurchaseOrderDetailModal } from './components/PurchaseOrderDetailModal';
export { SupplierAccountModal } from './components/SupplierAccountModal';
export { PurchaseReturnModal } from './components/PurchaseReturnModal';
export { StockTransferModal } from './components/StockTransferModal';
